export const CHAT_SCHEDULING_KEYWORDS_LIST = [
    "näyttö",
    "esittely",
    "nähdään",
    "katsomaan",
    "kellonaika",
    "sopii",
    "aika",
    "ajankohta",
    "päivä",
    "huomenna",
    "iltapäivä",
    "aamupäivä",
    "ilta",
    "päivämäärä",
    "sovitaan",
    "onnistuu",
    "käy",
    "kävisi",
    "tulemaan",
    "pääset",
    "pääsisit",
    "sopisi",
    "järjestän",
    "ehdottaa",
    "varata",
    "tavataan",
    "osoite",
    "showing",
    "viewing",
    "tour",
    "see the place",
    "time",
    "works",
    "suits",
    "date",
    "tomorrow",
    "afternoon",
    "morning",
    "evening",
    "schedule",
    "visit",
    "arrange",
    "suggest",
    "book",
    "let's meet",
    "address"
]
